import { render } from "./PrefixSuffixWrapper.vue.js?vue&type=template&id=575e5237!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrefixSuffixWrapper.vue?vue&type=template&id=575e5237"
import script from "./PrefixSuffixWrapper.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrefixSuffixWrapper.vue?vue&type=script&lang=js"
export * from "./PrefixSuffixWrapper.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrefixSuffixWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/components/PrefixSuffixWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "575e5237"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('575e5237', __exports__)) {
    api.reload('575e5237', __exports__)
  }
  
  module.hot.accept("./PrefixSuffixWrapper.vue.js?vue&type=template&id=575e5237!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrefixSuffixWrapper.vue?vue&type=template&id=575e5237", () => {
    api.rerender('575e5237', render)
  })

}


export default __exports__